import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import LookupGeneric from "./lookupGeneric";
import ServiceOfferingService from "../../src/Services/ServiceOffering.service";
const ServiceOfferingLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        defaultIds: props.defaultIds,
        fetchItemsById: (ids) => {
            return ServiceOfferingService.findByIds(ids);
        },
        fetchOptions: (search) => {
            return ServiceOfferingService.searchActive(search);
        },
        optionRenderer: function optionRenderer(serviceOffering) {
            return _jsx("span", { children: serviceOffering.name });
        },
    });
};
export default ServiceOfferingLookup;
